<template>
  <div>
    <b-row>
      <b-col>
        <base-input label="Data de Disponibilização:" :show-warning="revisao('data_disponibilizacao')">
          <DateInput
            input-class="form-control"
            v-model="oportunidade.data_disponibilizacao"
            format="dd/MM/yyyy"
            :state="validateState('data_disponibilizacao')"
          />
        </base-input>
      </b-col>
      <b-col>
        <base-input label="Data de Início das Propostas:" :show-warning="revisao('data_proposta_ini')">
          <DateInput
            input-class="form-control"
            v-model="oportunidade.data_proposta_ini"
            format="dd/MM/yyyy"
          />
        </base-input>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <base-input label="Data de Encerramento das Propostas:" :show-warning="revisao('data_proposta_fim')">
          <DateInput
            input-class="form-control"
            v-model="oportunidade.data_proposta_fim"
            :disabled="disabled_fim"
            format="dd/MM/yyyy"
          />
          <b-form-invalid-feedback :state="validateState('data_proposta_fim')"
            >Data de encerramento é um campo
            obrigatório quando tipo é "DETERMINADA".</b-form-invalid-feedback
          >
        </base-input>
      </b-col>

      <b-col>
        <base-input label="Tipo de Encerramento:" :show-warning="revisao('data_proposta_fim_tipo')">
          <b-form-select
            v-model="oportunidade.data_proposta_fim_tipo"
            :options="[
              { value: 'determinada', text: 'Determinada' },
              { value: 'indeterminada', text: 'Indeterminada' },
              { value: 'continua', text: 'Contínua' },
            ]"
          ></b-form-select>
        </base-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { requiredIf } from "vuelidate/lib/validators";

import { mapState } from "vuex";
import DateInput from "@/components/Form/DateInput.vue";
import BaseInput from "./BaseInput.vue";

export default {
  mixins: [validationMixin],
  components: { DateInput, BaseInput },

  validations: {
    oportunidade: {
      data_disponibilizacao: {},
      data_proposta_fim: {
        required: requiredIf(function (model) {
          return model.data_proposta_fim_tipo == "determinada";
        }),
      },
    },
  },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
    disabled_fim() {
      return this.oportunidade.data_proposta_fim_tipo != "determinada";
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.oportunidade.$touch();
      return !this.$v.oportunidade.$anyError;
    },
    revisao(campo) {
      if (!this.oportunidade || !this.oportunidade.campos_revisao) return false;

      const camposInicio = [
        'voluntaria_data_inicio',
        'emenda_data_inicio',
        'data_inicio_beneficiario_especifico'
      ];

      const camposFim = [
        'voluntaria_data_fim',
        'emenda_data_fim',
        'data_fim_beneficiario_especifico'
      ];

      if (campo === 'data_proposta_ini') {
        return this.oportunidade.campos_revisao.some(item =>
          camposInicio.includes(item.campo)
        );
      }

      if (campo === 'data_proposta_fim') {
        return this.oportunidade.campos_revisao.some(item =>
          camposFim.includes(item.campo)
        );
      }

      return this.oportunidade.campos_revisao.some(item => item.campo === campo);
    },
  },
};
</script>
